
import { Component, Prop, Vue } from 'vue-property-decorator'
import TitlePage from '@/components/atoms/TitlePage.vue'
import TextFrame from '@/components/atoms/TextFrame.vue'
import PanelFrame from '@/components/molecules/PanelFrame.vue'
import ButtonLogin from '@/components/molecules/ButtonLogin.vue'

/**
 * 仮ユーザ用のメッセージ表示画面レイアウト
 */
@Component({
  components: {
    TitlePage,
    TextFrame,
    PanelFrame,
    ButtonLogin,
  },
})
export default class ActivateMessage extends Vue {
  /** ボタン押下時処理 */
  @Prop()
  eventSubmit?: () => Promise<void>
}
